module.exports = __webpack_public_path__ + "static/media/logo-mini.25b18266.svg";